// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3AUCL","title":"AfterFrontImage_title__3loRC"};